import Esqueleto from "../../../components/Esqueleto";
import { useState } from "react";
import Relatorio from "../../../../models/Relatorio";
import BarrasHorizontais from "../BarrasHorizontais";
import FiltrosPlantio from "../FiltrosPlantio";
import TabelaAdmin from "../../../components/TabelaAdmin";
import { COR_SERIE, Filtros, Secao } from "../painel";
import { numero, useRelatorio } from "../useRelatorio";

const INICIAL = { id: "especies", de: "", ate: "", tipo_categoria: "", tipo: "" };

// "Espécies mais plantadas": as 10 espécies com mais mudas, nos mesmos filtros de
// período, categoria e tipo dos plantios.
export default function EspeciesMaisPlantadas() {
  const [filtros, setFiltros] = useState(INICIAL);
  const alterar = (parte) => setFiltros((atual) => ({ ...atual, ...parte }));
  const periodoInvertido = filtros.de && filtros.ate && filtros.de > filtros.ate;
  const filtrado = JSON.stringify(filtros) !== JSON.stringify(INICIAL);

  const { dados, erro, carregando } = useRelatorio(
    Relatorio.especies,
    { de: filtros.de, ate: filtros.ate, tipo_categoria: filtros.tipo_categoria, tipo: filtros.tipo, limite: 10 },
    !periodoInvertido,
  );

  const itens = dados?.itens || [];
  const nome = (e) => e.nome_comum || e.nome_cientifico;

  return (
    <Secao aria-labelledby="titulo-especies">
      <div>
        <h3 id="titulo-especies">Espécies mais plantadas</h3>
        <p className="sub">As 10 espécies com mais mudas registradas.</p>
      </div>

      <Filtros>
        <FiltrosPlantio valores={filtros} onChange={alterar} />
        {filtrado && <button type="button" className="limpar" onClick={() => setFiltros(INICIAL)}>Limpar filtros</button>}
        {periodoInvertido && <span className="aviso" role="alert">A data inicial é depois da final.</span>}
      </Filtros>

      {carregando && <Esqueleto variante="barras" quantidade={8} rotulo="Carregando relatório" />}
      {erro && <div className="erro" role="alert">{erro}</div>}

      {!carregando && !erro && dados && (itens.length === 0
        ? <div className="vazio">Nenhuma espécie encontrada com esses filtros.</div>
        : (
          <>
            <BarrasHorizontais
              rotulos={itens.map(nome)}
              series={[{ name: "Mudas", color: COR_SERIE, data: itens.map((e) => e.mudas) }]}
              tooltip={(i) => `<strong>${nome(itens[i])}</strong><br/><em>${itens[i].nome_cientifico}</em><br/>${numero(itens[i].mudas)} mudas em ${numero(itens[i].plantios)} plantios`}
              descricao="Espécies mais plantadas, por número de mudas. Os valores estão na tabela abaixo."
            />

            <TabelaAdmin
              rotulo="Espécies por número de mudas"
              linhas={itens}
              chave={(e) => e.id}
              larguraMinima={520}
              paginar={25} itens="espécies"
              colunas={[
                { id: "especie", rotulo: "Espécie", largura: "minmax(220px, 4fr)",
                  celula: (e) => (
                    <span className="rotulo-linha">
                      {nome(e)}
                      {e.nome_comum && <small><em>{e.nome_cientifico}</em></small>}
                    </span>
                  ) },
                { id: "mudas", rotulo: "Mudas", largura: "minmax(90px, 1fr)", direita: true, celula: (e) => numero(e.mudas) },
                { id: "plantios", rotulo: "Plantios", largura: "minmax(90px, 1fr)", direita: true, celula: (e) => numero(e.plantios) },
              ]}
            />
          </>
        ))}
    </Secao>
  );
}
